<template>
  <div class="w-full flex flex-col gap-2">
    <!-- <AppTablePagination
      :visibility="this.validPermission('N0006')"
      :show="show_table"
      table_title="Contactos"
      @row-clicked="select"
      @close="close_table"
      class="h-full"
      urlString="contacto"
      :refresh.sync="refresh"
      :filterData="filtroData"
      :order_by="order_by"
      :page_size="page_size"
    /> -->
    <GenericDataTable
      :visibility="this.validPermission('N0006')"
      :show_export="true"
      :apiUrl="`${baseURl}/api/v1/contacto/pagination/`"
      :columns="contactoColumns"
      :table_data="contactos"
      table_title="Contactos"
      @row-clicked="select"
      @close="close_table"
    />
  </div>
</template>
<script>
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import permissionMixin from "@/permissionMixin.js";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";

export default {
  mixins: [permissionMixin],
  name: "appContacto",
  components: {
    AppTablePagination,
    GenericDataTable,
  },
  data() {
    return {
      refresh: false,
      baseURl: process.env.VUE_APP_URL_BASE,
      contactos: [],
      utilizador_perfils: {},
      show_table: true,
      contactoColumns: [
        {
          key: "nome",
          label: "Nome",
          type: "string",
        },
        {
          key: "email",
          label: "Email",
          type: "string",
        },
        {
          key: "telefone",
          label: "Telefone",
          type: "string",
        },
        {
            key: "descricao",
            label: "Descrição",
            type: "string",
        },
        {
          key: "telemovel",
          label: "Telemóvel",
          type: "string",
        },
        {
          key: "tipo.nome",
          label: "Tipo",
          type: "string",
        },
        {
            key: "status",
            label: "Estado",
            type: "badge",
        }
      ],
    };
  },

  methods: {},
};
</script>
